import React from 'react';
import { MetricsDateRange } from '@modules/monitor/resource-triage/components/MetricsTrendPanel';
import DatePicker from 'js/components/elements/datepicker/DatePicker';
import { defaultStaticRanges, defineds } from 'js/components/elements/datepicker/defaultRanges';

interface FlowOverviewDateControlsProps {
  start: Date;
  end: Date;
  onDatesChanged: (dates: MetricsDateRange) => void;
}

const FlowOverviewDateControls = ({
  start,
  end,
  onDatesChanged,
}: FlowOverviewDateControlsProps) => {
  return (
    <DatePicker
      onSelect={(range: { startDate: Date; endDate: Date }) => {
        onDatesChanged({ start: range.startDate, end: range.endDate });
      }}
      data={{ startDate: start, endDate: end, key: 'selection' }}
      staticRanges={defaultStaticRanges}
      dateFormat="MM/dd/yyyy"
      extraProps={{
        maxDate: defineds.endOfToday,
      }}
    />
  );
};

FlowOverviewDateControls.displayName = 'FlowOverviewDateControls';

export default FlowOverviewDateControls;
